export default __webpack_public_path__ + "static/media/promos-1.549c8ae9.webp";